export default "__VITE_ASSET__a648668d__"